// components/search/AdvancedSearchForm.jsx
import React from "react";
import { Input, DatePicker, Select, Button } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { agreementOptions } from "../../utils/Constant";

const { Option } = Select;

const AdvancedSearchForm = ({
  searchFields,
  setSearchFields,
  handleAdvanceSearch,
  onClose
}) => {

  const clearFilters = () => {
    setSearchFields({
      first_name: '',
      created_at: null,
      agreement_type: '',
      name_of_client: '',
      nature: '',
      status: '',
      effective_date: null,
      execution_date: null,
      tenure: '',
      termination_notice: '',
      invoice_frequency: '',
      invoice_date: null,
      credit_term: '',
      contract_currency_value: '',
      contract_currency: '',
      value: '',
      custom_field: '',
      product_name: ''
    });
  };

    const NatureOfPaymentType = [
    { value: "customer", label: "Customer" },
    { value: "vendor", label: "Vendor" },
    { value: "partnership", label: "Partnership" },
  ];

  return (
    <div className="w-[700px] p-4 border-[1.4px] shadow-custom-shadow border-[#bca5fa] rounded-md bg-[#EDE9FE] mt-4 absolute top-4 left-0 z-[999]">
      
      <CloseOutlined
        onClick={onClose}
        style={{ fontSize: '16px', color: 'red', float: 'right' }}
      />

      <div className="grid grid-cols-4 gap-3 mt-2">

        {/* Date of Raising */}
        <div className="text-xs">
          <label className="block mb-1">Date of Raising</label>
          <DatePicker
            size="small"
            className="w-full border-0 border-b bg-[#EDE9FE] border-gray-400 rounded-none"
            value={searchFields.created_at}
            onChange={(date) => setSearchFields(prev => ({ ...prev, created_at: date }))}
          />
        </div>

        {/* Partner Name */}
        <div className="text-xs">
          <label className="block mb-1">Partner Name</label>
          <Input
            size="small"
            placeholder="Partner Name"
            className="border-0 border-b bg-[#EDE9FE] border-gray-400 rounded-none"
            value={searchFields.name_of_client}
            onChange={(e) => setSearchFields(prev => ({ ...prev, name_of_client: e.target.value }))}
          />
        </div>

        {/* Agreement Type */}
        <div className="text-xs only-bottom-border-select col-span-2">
          <label className="block mb-1">Agreement Type</label>
          <Select
            size="small"
            placeholder="Select Agreement Type"
            value={searchFields.agreement_type}
            onChange={(value) => setSearchFields(prev => ({ ...prev, agreement_type: value }))}
            allowClear
            showSearch
            optionFilterProp="label"
            className="w-full custom-select-border"
          >
            {agreementOptions.map(option => (
              <Option key={option.value} value={option.value} label={option.label}>
                {option.label}
              </Option>
            ))}
          </Select>
        </div>

        {/* Effective Date */}
        <div className="text-xs col-span-2">
          <label className="block mb-1">Effective Date</label>
          <DatePicker
            size="small"
            className="w-full border-0 border-b bg-[#EDE9FE] border-gray-400 rounded-none"
            value={searchFields.effective_date}
            onChange={(date) => setSearchFields(prev => ({ ...prev, effective_date: date }))}
          />
        </div>

        {/* Execution Date */}
        <div className="text-xs col-span-2">
          <label className="block mb-1">Execution Date</label>
          <DatePicker
            size="small"
            className="w-full border-0 border-b bg-[#EDE9FE] border-gray-400 rounded-none"
            value={searchFields.execution_date}
            onChange={(date) => setSearchFields(prev => ({ ...prev, execution_date: date }))}
          />
        </div>

        {/* Termination Notice */}
        <div className="text-xs">
          <label className="block mb-1">Termination Notice</label>
          <Input
            size="small"
            placeholder="Termination Notice"
            className="border-0 border-b bg-[#EDE9FE] border-gray-400 rounded-none"
            value={searchFields.termination_notice}
            onChange={(e) => setSearchFields(prev => ({ ...prev, termination_notice: e.target.value }))}
          />
        </div>

        {/* Status */}
        <div className="text-xs only-bottom-border-select col-span-2">
          <label className="block mb-1">Status</label>
          <Select
            size="small"
            placeholder="Select Status"
            className="w-full"
            value={searchFields.status}
            onChange={(value) => setSearchFields(prev => ({ ...prev, status: value }))}
          >
            <Select.Option value="FRESH_REQUEST">Fresh Request</Select.Option>
            <Select.Option value="UNDER_NEGOTIATION">Under Negotiation</Select.Option>
            <Select.Option value="UNDER_EXECUTION">Under Execution</Select.Option>
            <Select.Option value="EXECUTED">Executed</Select.Option>
            <Select.Option value="TRANSACTION_CLOSED">Transaction Closed</Select.Option>
          </Select>
        </div>

        {/* Nature */}
        <div className="text-xs">
          <label className="block mb-1">Nature</label>
          <Select
            size="small"
            placeholder="Select Nature"
            className="w-full"
            value={searchFields.nature}
            onChange={(value) => setSearchFields(prev => ({ ...prev, nature: value }))}
            allowClear
            showSearch
            optionFilterProp="label"
          >
            {NatureOfPaymentType.map(option => (
              <Select.Option key={option.value} value={option.value} label={option.label}>
                {option.label}
              </Select.Option>
            ))}
          </Select>
        </div>

        {/* Product Name */}
        <div className="text-xs">
          <label className="block mb-1">Product Name</label>
          <Input
            size="small"
            placeholder="Product Name"
            className="border-0 border-b bg-[#EDE9FE] border-gray-400 rounded-none"
            value={searchFields.product_name}
            onChange={(e) => setSearchFields(prev => ({ ...prev, product_name: e.target.value }))}
          />
        </div>

        {/* Invoice Date */}
        <div className="text-xs">
          <label className="block mb-1">Invoice Raising Date</label>
          <Input
            size="small"
            placeholder="Invoice Raising Date"
            className="border-0 border-b bg-[#EDE9FE] border-gray-400 rounded-none"
            value={searchFields.invoice_date}
            onChange={(e) => setSearchFields(prev => ({ ...prev, invoice_date: e.target.value }))}
          />
        </div>

        {/* Invoice Frequency */}
        <div className="text-xs">
          <label className="block mb-1">Invoice Frequency</label>
          <Input
            size="small"
            placeholder="Invoice Frequency"
            className="border-0 border-b bg-[#EDE9FE] border-gray-400 rounded-none"
            value={searchFields.invoice_frequency}
            onChange={(e) => setSearchFields(prev => ({ ...prev, invoice_frequency: e.target.value }))}
          />
        </div>

        {/* Contract Currency */}
        <div className="text-xs">
          <label className="block mb-1">Contract Currency</label>
          <Input
            size="small"
            placeholder="Contract Currency"
            className="border-0 border-b bg-[#EDE9FE] border-gray-400 rounded-none"
            value={searchFields.contract_currency}
            onChange={(e) => setSearchFields(prev => ({ ...prev, contract_currency: e.target.value }))}
          />
        </div>

        {/* Contract Currency Value */}
        <div className="text-xs">
          <label className="block mb-1">Currency Value</label>
          <Input
            size="small"
            placeholder="Currency Value"
            className="border-0 border-b bg-[#EDE9FE] border-gray-400 rounded-none"
            value={searchFields.contract_currency_value}
            onChange={(e) => setSearchFields(prev => ({ ...prev, contract_currency_value: e.target.value }))}
          />
        </div>

        {/* Base Value */}
        <div className="text-xs">
          <label className="block mb-1">Base Value</label>
          <Input
            size="small"
            placeholder="Base Value"
            className="border-0 border-b bg-[#EDE9FE] border-gray-400 rounded-none"
            value={searchFields.value}
            onChange={(e) => setSearchFields(prev => ({ ...prev, value: e.target.value }))}
          />
        </div>

      </div>

      {/* Footer Buttons */}
      <div className="flex justify-between mt-3">
        <Button type="primary" onClick={clearFilters}>
          Clear filter
        </Button>
        <Button type="primary" onClick={handleAdvanceSearch}>
          Search
        </Button>
      </div>
    </div>
  );
};

export default AdvancedSearchForm;
